module.exports = __webpack_public_path__ + "img/buySuccess.95a3c33c.png";